import type {QuoteRate} from './quote-builder-logic'

/** TODO: Back wash-out / disposal defaults with a fee catalog or config API. */
export const HARDCODED_FEE_RATES = {
    washOut: {
        rateType: 'flat' as const,
        price: 150,
        defaultName: 'Wash-out fee',
    },
    disposal: {
        rateType: 'flat' as const,
        price: 300,
        defaultName: 'Disposal fee',
    },
} satisfies Record<'washOut' | 'disposal', QuoteRate>

export function getDefaultFeeRate(feeKey: 'washOut' | 'disposal'): QuoteRate {
    return HARDCODED_FEE_RATES[feeKey]
}
